module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_02-36cfaa892d474349587e111e80efa799.jpg";